/*
 * Copyright (c) 2021.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Nikita Tropin <ntropin@yandex.ru>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {AfterContentInit, ChangeDetectionStrategy, Component, Input, OnChanges, OnDestroy, OnInit} from '@angular/core';
import {ReactiveFormsModule, UntypedFormControl} from '@angular/forms';
import {NbButtonModule, NbInputModule, NbWindowRef} from '@nebular/theme';
import {BaseComponent, ProductCustomer, ProductStatuses} from 'compob2b-libs';
import {Subject} from 'rxjs';
import {debounceTime, distinctUntilChanged, takeUntil, tap} from 'rxjs/operators';
import {translations} from '../../../../environments/translations.ru';
import {TuiIcon} from '@taiga-ui/core'
import {LowerCasePipe} from '@angular/common'
import {DigitOnlyDirective} from '@uiowa/digit-only'

@Component({
  selector: 'app-add-to-specification',
  templateUrl: './add-to-specification.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TuiIcon,
    ReactiveFormsModule,
    NbInputModule,
    LowerCasePipe,
    DigitOnlyDirective,
    NbButtonModule
  ]
})
export class AddToSpecificationComponent extends BaseComponent implements OnInit, OnChanges, OnDestroy, AfterContentInit {

  @Input() product: ProductCustomer;
  multiplicityOrder = 1;
  multiplicityHeader = translations.multiplicity;
  inputFormControl: UntypedFormControl;
  discount: number;
  private inputSub$ = new Subject<number>();

  constructor(protected readonly windowRef: NbWindowRef) {
    super();
  }

  ngOnChanges(): void {
    if (!this.loading) {
      this.inputFormControl = new UntypedFormControl();

      let multiplicity = this.product.multiplicityOrder;

      if (this.product.productStatusId === ProductStatuses.ORDER) {
        multiplicity = this.product.multiplicitySupplier;
      }

      if (multiplicity > 0) {
        this.multiplicityOrder = multiplicity;
      }

      this.inputFormControl.setValue(this.multiplicityOrder);
    }
  }

  ngOnInit(): void {
    this.inputSub$.pipe(
      debounceTime(600),
      takeUntil(this.unsubscribe),
      distinctUntilChanged(),
      tap(val => this.manual(val))
    ).subscribe();
  }

  ngAfterContentInit(): void {
    this.discount = Math.round((this.product.price - this.product.commercePrice.price) / this.product.price * 100);
    this.cdr.detectChanges();
  }

  increase() {
    this.changeInputValue(this.inputFormControl.value + this.multiplicityOrder);
  }

  decrease() {
    const res = this.inputFormControl.value - this.multiplicityOrder;
    if (res % this.multiplicityOrder === 0 && res > 0) {
      this.changeInputValue(res);
    }
  }

  onKeyDown(event) {
    switch (event.key) {
      case 'ArrowUp':
        this.increase();
        break;
      case 'ArrowDown':
        this.decrease();
        break;
    }
  }

  manualChange() {
    this.inputSub$.next(this.inputFormControl.value);
  }

  private manual(value: number) {
    let res = Math.ceil(value / this.multiplicityOrder) * this.multiplicityOrder;
    if (res === 0) {
      res = this.multiplicityOrder;
    }
    this.changeInputValue(res);
  }

  private changeInputValue(value: number) {
    this.inputFormControl.setValue(value);
  }

  addToSpecification() {
    this.windowRef.close({product: this.product, amount: this.inputFormControl.value});
  }

}
